module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--pasttalk-9d42ea8f88f96723bf7a64854fe2ad35.png";